
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>

    <div class="label yellow-label">withdrawal is limited</div>
    <div class="_10px-spacer"></div>
    <h3>Restricted withdrawal</h3>
    <img src="/assets/images/v2/withdraw-disabled.svg" height="200" />
    <p>You have active bonuses that must be either completed or dismissed.</p>
    <a [routerLink]="['/account/bonus', { outlets: { modal: null } }]" (click)="close()">
      <app-form-button class="primary full-width">Manage</app-form-button>
    </a>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/active-bonuses-modal.component.ts.ModalActiveBonusesComponent.html